import axios from "axios"
import baseURL from "../config/api"

export const post_SendLeadershipEmail = async (data: any, token: string) => {
    return await axios({
        url: `${baseURL}email/SendLeadershipEmail`,
        method: "POST",
        data,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true
    }).then(response => response.data);
}

export const post_SendMinistryEmail = async (data: any, token: string) => {
    return await axios({
        url: `${baseURL}email/SendMinistryEmail`,
        method: "POST",
        data,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true
    }).then(response => response.data);
}
